import { render, staticRenderFns } from "./addCandidatesSectionModal.vue?vue&type=template&id=57b9a595&scoped=true"
import script from "./addCandidatesSectionModal.vue?vue&type=script&lang=js"
export * from "./addCandidatesSectionModal.vue?vue&type=script&lang=js"
import style0 from "./addCandidatesSectionModal.vue?vue&type=style&index=0&id=57b9a595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b9a595",
  null
  
)

export default component.exports